import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { TrainingNavbar } from "./reusedcomponent/navbar";
import DatePicker from "react-datepicker";
import { ApiService } from "../../../services/ApiService";
import { Formik, Form, Field } from "formik";
import { useAlert } from "react-alert";
import Select from "react-select";

export const EditMunch = ({closeModal, route }) => {
  const [users, setUsers] = useState([]);
  const [munches, setMunches] = useState(null);

  const alert = useAlert();
  const request = async () => {
    const getUser = await ApiService.post("get-all-active-users");
    const data = await ApiService.get(`edit-munch/${route.match.params.id}`);
    console.log(data.data.data);

    setMunches(data.data.data);
    setUsers(getUser.data.data);
    closeModal();
  };

  useEffect(() => {
    request();
  }, []);

  return (
    <React.Fragment>
      <TrainingNavbar />
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="table-wrapper table-responsive">
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 col-xs-12"
                    id="munch_learn_content_wrapper"
                  >
                    <div class="">
                      {munches !== null ? (
                        <Formik
                          initialValues={{
                            name: munches.name,
                            presentation_type: munches.presentation_type,
                            due_date: munches.due_date,
                            email: munches.email,
                            topic: munches.topic,
                          }}
                          validate={(values) => {
                            const errors = {};
                            // if (!values.email) {
                            //     errors.email = "Required";
                            // } else if (
                            //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                            //         values.email
                            //     )
                            // ) {
                            //     errors.email = "Invalid email address";
                            // }
                            // return errors;
                          }}
                          onSubmit={(values) => {
                            console.log(users);
                            // ApiService.post("create-munch", values).then(res => {
                            //     console.log(res)
                            //     if(res.data.type===false){
                            //         alert.error(res.data.msg)
                            //     }else if(res.data.type === true){
                            //     alert.success(res.data.msg)
                            // }
                            // })
                          }}
                        >
                          {({ isSubmitting, values, setFieldValue }) => (
                            <Form>
                              <div>
                                <div className="form-group">
                                  <label>
                                    Presentation Type{" "}
                                    <span className="text-danger"> * </span>
                                  </label>
                                  <Field
                                    as="select"
                                    className="form-control"
                                    id="presentation_type"
                                    name="presentation_type"
                                  >
                                    <option selected>
                                      --Select Presentation Type--
                                    </option>
                                    <option value="individual">
                                      Individual
                                    </option>
                                    <option value="paired">Paired</option>
                                    <option value="guest">Guest</option>
                                    ))
                                  </Field>
                                </div>

                                <div className="form-group">
                                  <label>
                                    Presenter{" "}
                                    <span className="text-danger"> * </span>
                                  </label>

                                  {values.presentation_type == "individual" ? (
                                    <Field
                                      as="select"
                                      className="form-control"
                                      name="name"
                                    >
                                      <option selected>--Select User--</option>

                                      {users.map((user, i) => (
                                        <option
                                          value={
                                            user.first_name +
                                            " " +
                                            user.last_name
                                          }
                                          key={i}
                                        >
                                          {user.first_name +
                                            " " +
                                            user.last_name}
                                        </option>
                                      ))}
                                    </Field>
                                  ) : null}

                                  {values.presentation_type == "paired" ? (
                                    <Select
                                      isMulti
                                      value={values.name}
                                      options={users.map((user) => ({
                                        label:
                                          user.first_name +
                                          " " +
                                          user.last_name,
                                        value:
                                          user.first_name +
                                          " " +
                                          user.last_name,
                                      }))}
                                      onChange={(date) =>
                                        setFieldValue("name", date)
                                      }
                                    />
                                  ) : null}

                                  {values.presentation_type == "guest" ? (
                                    <Field
                                      type="text"
                                      id="tpoic"
                                      className="form-control item"
                                      name="name"
                                      placeholder="Enter Guest Name"
                                    />
                                  ) : null}
                                </div>

                                <div className="form-group">
                                  <label>
                                    Presenter Email{" "}
                                    <span className="text-danger"> * </span>
                                  </label>
                                  <Field
                                    as="select"
                                    className="form-control"
                                    name="email"
                                  >
                                    {/* {users.map((user, i) => (
                                                                <option value={user.email} key={i}>
                                                                {user.email}
                                                                </option>
                                                            ))} */}
                                  </Field>
                                </div>
                                <div className="form-group">
                                  <label>
                                    Due Date{" "}
                                    <span className="text-danger"> * </span>
                                  </label>
                                  <div className="form-group">
                                    <DatePicker
                                      selected={Date.parse(values.due_date)}
                                      dateFormat="MMMM d, yyyy"
                                      className="form-control"
                                      name="due_date"
                                      onChange={(date) =>
                                        setFieldValue("due_date", date)
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="form-group">
                                  <label>Topic</label>
                                  <Field
                                    type="text"
                                    id="tpoic"
                                    className="form-control item"
                                    name="topic"
                                    placeholder="Enter Topic"
                                  />
                                </div>
                                <div className="form-group row">
                                    <div className="col">
                                      <button
                                        type="button"
                                        className="btn btn-danger btn-sm"
                                        onClick={closeModal}
                                      >
                                        Close
                                      </button>
                                    </div>
                                    <div className="col">
                                      <button
                                        type="submit"
                                        className="btn btn-block nt-button-color-default"
                                      >
                                        Submit
                                      </button>
                                    </div>
                                </div>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/trainingmanagement/edit_ml.js